import React, {Component} from 'react';

import MPPhoto from "./0_Popup/0_0_Photo";
import MPProfile from "./0_Popup/0_1_Profile";
import MPIntroduce from "./0_Popup/0_2_Introduce";
import MPIds from "./0_Popup/0_3_Ids";

class MBasic extends Component {
	constructor(props) {
		super(props);

		this.state = {
			activeTab: '',
			isShowEditPhoto : false,
			isShowEditProfile : false,
			isShowEditIds : false,
			isShowEditIntroduce : false,
		}

		this.showEditPopup = this.showEditPopup.bind(this);
		this.onUpdate = this.onUpdate.bind(this);
	}

	showEditPopup (key) {
		let t = {};
		t[key] = !this.state[key];
		this.setState(t)
	}

	onUpdate(record) {
		this.props.onUpdate(record);
	}

	render() {
		const record = this.props.record;

		return (
			<div>
				<div className="row row-cols-2 ml-n2 mr-n2">
					<div className="col pl-2 pr-2">
						<div className="user-personal-info">
							<div className="user-personal-data mb-3">
								<div className="user-picture">
									<div className="thumb">
										<button type="button" className="btn-picture-modify"
												onClick={() => this.showEditPopup('isShowEditPhoto')}>
											<span className="icon icon-size-24 icon-camera-white"/>
										</button>
										<img
											src={record.profile_pic ? record.profile_pic : rmVars.themeUrl + '/assets/images/user_picture.png'}
											alt=""/></div>
								</div>
								<div className="user-data">
									<div className="kr-name">{record.scholar_name}</div>
									<div className="en-name">{record.scholar_name_en || '입력된 정보가 없습니다.'}</div>
									<div
										className="cate">{record.sinbun_name} / {record.col_name} {record.dept_name} {record.maj_name}</div>
								</div>
							</div>
							<div className="user-personal-notice mt-px-50">
								<p className="text-muted small lh-1-4">
									시스템 고도화로 인해 <br/>
									<span style={{color: 'red'}}>소개·학력·경력</span> 정보 수정 기능이
									일시적으로 제공되지 않습니다.
								</p>
							</div>

							<div className="user-personal-modify">
								<button type="button" className="btn btn-outline-gray"
										onClick={() => this.showEditPopup('isShowEditProfile')}>
									<span className="color-lightblue">기본 프로필<br/>수정</span>
								</button>
								<button
									type="button"
									className="btn btn-outline-gray"
									disabled
								>
									<span className="color-lightblue">소개·학력<br/>·경력 수정</span>
								</button>
								{/*<button type="button" className="btn btn-outline-gray"*/}
								{/*		onClick={() => this.showEditPopup('isShowEditIntroduce')}>*/}
								{/*	<span className="color-lightblue">소개·학력<br/>·경력 수정</span>*/}
								{/*</button>*/}
								<button type="button" className="btn btn-outline-gray"
										onClick={() => this.showEditPopup('isShowEditIds')}>
									<span className="color-lightblue">연구자 ID<br/>수정</span>
								</button>
							</div>

						</div>
					</div>
					<div className="col pl-2 pr-2">
						<h6>연구자 ID</h6>
						<div className="user-profile-list">
							{record.school_no ?
								<div className="list-cell"><strong>교직원번호(대표)</strong>
									<div className="txt">{record.school_no}</div>
								</div>
								: ''
							}
							{record.orcid ?
								<div className="list-cell"><strong>ORCID</strong>
									<div className="txt">{record.orcid}</div>
								</div>
								: ''
							}
							{record.researchgate_id ?
								<div className="list-cell"><strong>ResearchGate ID</strong>
									<div className="txt">{record.researchgate_id}</div>
								</div>
								: ''
							}
							{record.scopus_id ?
								<div className="list-cell"><strong>Scopus ID</strong>
									<div className="txt">{record.scopus_id}</div>
								</div>
								: ''
							}
							{record.researcher_id ?
								<div className="list-cell"><strong>Researcher ID</strong>
									<div className="txt">{record.researcher_id}</div>
								</div>
								: ''
							}
							{record.kci_id ?
								<div className="list-cell"><strong>KCI ID</strong>
									<div className="txt">{record.kci_id}</div>
								</div>
								: ''
							}
							{record.googlescholar_id ?
								<div className="list-cell"><strong>GoogleScholar ID</strong>
									<div className="txt">{record.googlescholar_id}</div>
								</div>
								: ''
							}
							{record.isni ?
								<div className="list-cell"><strong>ISNI</strong>
									<div className="txt">{record.isni}</div>
								</div>
								: ''
							}
							{record.research_ids.length > 0 && record.research_ids.map((item, index) => {
								return (
									<div key={index} className="list-cell"><strong>{item.label}</strong>
										<div className="txt">{item.id_value}</div>
									</div>
								)
							})}
						</div>
						<div className="user-profile-list">
							<div className="list-cell"><em>연구실</em>
								<div className="txt">{record.lab_name ? record.lab_name : '입력된 정보가 없습니다.'}</div>
							</div>
							<div className="list-cell"><em>이메일</em>
								<div className="txt">{record.email ? record.email : '입력된 정보가 없습니다.'}</div>
							</div>
							<div className="list-cell"><em>홈페이지</em>
								<div className="txt">{record.homepage ? record.homepage : '입력된 정보가 없습니다.'}</div>
							</div>
						</div>
					</div>
				</div>

				{this.state.isShowEditPhoto &&
					<MPPhoto
						record={record}
						closePopup={this.showEditPopup}
						onUpdate={this.onUpdate}
					/>
				}

				{this.state.isShowEditProfile &&
					<MPProfile
						record={record}
						closePopup={this.showEditPopup}
						onUpdate={this.onUpdate}
					/>
				}

				{this.state.isShowEditIds &&
					<MPIds
						record={record}
						closePopup={this.showEditPopup}
					/>
				}

				{(this.state.isShowEditIntroduce && record) &&
					<MPIntroduce
						record={record}
						closePopup={this.showEditPopup}
						onUpdate={this.onUpdate}
					/>
				}
			</div>
		);
	}
};

export default MBasic;
